/* eslint-disable max-len */
import { number, string } from 'prop-types';
import React from 'react';

const IconCheckboxChecked = ({
  size = 16,
  fill = '#4F4F4F',
  stroke = '#94A2B7',
}) => {
  return (
    <svg className="icon-checkbox-checked" width={size} height={size} viewBox="0 0 16 16" fill="none">
      <rect
        x="0.5"
        y="0.5"
        width="15"
        height="15"
        rx="1.5"
        fill={stroke}
        fillOpacity="0.2"
        stroke={stroke}
      />
      <path
        d="M13.808 4.58468L13.4149 4.19161C13.2914 4.068 13.1267 4 12.9509 4C12.7751 4 12.6104 4.068 12.4868 4.19161L6.96361 9.71474L3.51278 6.26381C3.38927 6.14039 3.22449 6.0723 3.04868 6.0723C2.87298 6.0723 2.70829 6.14039 2.58468 6.26381L2.19151 6.65678C2.0679 6.78059 2 6.94547 2 7.12108C2 7.29678 2.0679 7.46157 2.19151 7.58517L6.08771 11.4812C6.09288 11.4885 6.09835 11.4953 6.10469 11.5016L6.49786 11.8882C6.62137 12.0113 6.78615 12.0729 6.96332 12.0729H6.96537C7.14127 12.0729 7.30605 12.0113 7.42937 11.8882L7.82264 11.4982C7.82898 11.4919 7.83435 11.4867 7.83757 11.4815L13.8079 5.51171C14.064 5.2562 14.064 4.84049 13.808 4.58468Z"
        fill={fill}
      />
    </svg>
  );
};
IconCheckboxChecked.propTypes ={
  size: number,
  fill: string,
  stroke: string,
}

export default IconCheckboxChecked;
